/**
 * Dynamic URL - Adds query parameters to links on user interaction
 * Uses WeakSet to track processed links and avoid duplicate processing
 */

let processedLinks = new WeakSet();

/**
 * Add query parameters to a link
 * @param {HTMLAnchorElement} link - The link element to process
 */
function addParams(link) {
  if (processedLinks.has(link)) return;

  const currentHref = link.getAttribute('href');
  const extraParams = link.getAttribute('data-params');

  if (currentHref && extraParams) {
    link.setAttribute('href', currentHref + '?' + extraParams);
    processedLinks.add(link);
  }
}

/**
 * Handle user interaction events
 * @param {Event} e - The event object
 */
function handleEvent(e) {
  // Ensure e.target is an Element before calling closest()
  if (e.target && e.target.closest && typeof e.target.closest === 'function') {
    const link = e.target.closest('a[data-params]');
    if (link) {
      addParams(link);
    }
  }
}

// Listen for user interactions on links with data-params attribute
document.addEventListener('mouseenter', handleEvent, true);
document.addEventListener('touchstart', handleEvent, { passive: true });
document.addEventListener('focus', handleEvent, true);
